// Header.js
import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <div className="container-fluid bg-primary text-white d-none d-lg-flex wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-2">
          <div className="d-flex align-items-center justify-content-between">
            <Link to="/">
              <h2 className="text-white fw-bold m-0">SMN</h2>
              <span style={{color:"wheat", fontSize: "13px", fontWeight:800}}>SAHIBZADA, MUJTABA & NAQVI</span>
            </Link>
            <div>
                <h5 className="m-0" style={{color:"white"}}>ADVOCATES & SOLICITORS</h5>
            </div>
            <div className="flex-column d-flex align-items-end justify-content-end">
              <small style={{fontWeight: 800, fontSize: "12px"}}><i className="fa fa-phone-alt me-1"></i>042-35464418</small>
              <small style={{fontWeight: 800, fontSize: "12px"}}><i className="fa fa-envelope me-1"></i><a style={{color:"white"}} href="mailto:Info@smnlegalservices.com">Info@smnlegalservices.com</a></small>
              <small style={{fontWeight: 800, fontSize: "12px"}}><i className="fa fa-map-marker-alt me-1"></i>11-A, Birdwood Link Lawrence Road, Lahore</small>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
